import client from './main-client';

export const getAllUserDocumentsApi = (params) => client().get(`/documents-uploader/?userId=${params.userId}`, { params });

export const addDocumentApi = (data) => client().post('/documents-uploader', data);

// export const updateSpecDocsApi = (data) => client().put(`/specDocs/${data._id}`, data);

export const removeDocumentApi = (params) => client().delete(`/documents-uploader/${params._id}/?userId=${params.userId}`);
